module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8023.41db638e.png";